<template>
    <div>
        <a-form-model layout="inline" :labelAlign="labelAlign" :rules="rules" :model="sender" ref="senderForm"
            class="underline_input_form">
            <div class="info_item_box">
                <div class="header_box">
                    <a-row type="flex" align="middle" :gutter="10">
                        <a-col>
                            <img src="~@/assets/images/function-service/ic_send2.png" width="26px" height="26px">
                        </a-col>
                        <a-col class="info_title">发货人信息</a-col>
                        <a-col class="example" @click="showModal">查看示例图</a-col> 
                        <a-modal 
                             title="示例图"
                             :visible="visible"  
                             @cancel="handleCancel"
                           > 
                           <p><img src="@/assets/images/function-service/example.png" alt=""></p>
                        </a-modal>
                    </a-row>
                    <div class="flex_v_center pointer" @click="showSenderModal">
                        <img src="~@/assets/images/function-service/ic_contact.png" width="15" height="18" />
                        <span class="header_right_label">通讯簿</span>
                    </div>
                </div>
                <div class="info_content">
                    <a-row type="flex">
                        <a-col flex="1">
                            <a-form-model-item label="发货人" prop="name">
                                <template v-if="sender.name">
                                    {{ sender.name }}，{{ sender.mobile }} 
                                    <span class="changeSender" @click="ChangeeditSender">更改</span>  
                                </template>
                                <template v-else>
                                    请使用通讯簿填写发货人信息
                                </template>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </a-form-model> 
        <sender-modal v-model="isShowSenderModal" @change="changeSender" :key="sendermodalKey" />
        <edit-sender-modal v-model="isShowEditModal" :editItem="currentEditItem" @ok="editSender" />

    </div>
</template>

<script>
import SenderModal from '@/components/common/express/SenderModal'
import EditSenderModal from '@/components/common/address/EditSenderModal'

export default {
    name: 'SenderForm',
    components: { SenderModal, EditSenderModal },
    model: {
        prop: 'sender',
        event: 'change'
    },
    props: {
        sender: {
            type: Object,
            required: true
        },
        labelAlign: {
            type: String,
            required: false,
            default: 'left'
        },
        isShowTip: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            isShowSenderModal: false,
            rules: {
                name: [
                    { required: true, message: '请输入寄件人姓名', trigger: ['blur', 'change'] }
                ],
                mobile: [
                    { required: true, message: '请输入寄件人手机号码', trigger: ['blur', 'change'] },
                    { validator: this.$validate.mobile, trigger: ['blur', 'change'] }
                ],
            },
            isShowEditModal: false,
            sendermodalKey: 1,
            currentEditItem: {},
            visible: false
        }
    },

    watch: {
        sender: {
            handler(obj) {
                this.currentEditItem = JSON.parse(JSON.stringify(obj))
                this.currentEditItem.seller_name = this.currentEditItem.name
                this.currentEditItem.tel = this.currentEditItem.mobile
                delete this.currentEditItem.name
                delete this.currentEditItem.mobile
            },
            deep: true
        }
    },


    methods: {
        showSenderModal() {
            this.isShowSenderModal = true
            this.sendermodalKey++
        },
        changeSender(_sender) {
            this.$refs.senderForm.clearValidate()
            const { id, seller_name, tel } = _sender
            const sender = { id, name: seller_name, mobile: tel }
            this.$emit('change', sender)
        },
        validate() {
            return new Promise((resolve, reject) => {
                this.$refs.senderForm.validate(valid => {
                    if (valid) {
                        resolve()
                    } else {
                        reject(new Error('senderForm has error'))
                    }
                })
            })
        },
        ChangeeditSender() {
            this.isShowEditModal = true
        },
        editSender(data) {
            const { name, tel } = data
            this.currentEditItem.seller_name = name
            this.currentEditItem.tel = tel

            this.sender.name = name
            this.sender.mobile = tel
        },
        showModal() {
          this.visible = true;
        },
       
        handleCancel() { 
          this.visible = false;
        },
    },
}
</script>

<style scoped>
.info_item_box .header_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    padding-right: 20px;
    height: 44px;
    background: #fafafa;
}

.info_item_box .info_title {
    font-size: 16px;
    font-weight: 400;
    font-family: "Alibaba PuHuiTi";
}

.header_right_label {
    font-size: 15px;
    margin-left: 5px;
}

.info_content {
    padding: 10px;
}

.info_item_box>>>.ant-form-item {
    width: 100%;
}

/* .info_item_box >>> .ant-row:nth-child(n + 2) {
    margin-top: 35px;
} */

::v-deep .ant-alert-warning {
    background-color: transparent;
}

::v-deep .ant-alert-message,
::v-deep .ant-alert-warning .ant-alert-icon {
    color: #ff1a36;
}

::v-deep .ant-btn {
    min-width: 40px;
    /* height: 22px; */
    padding: 0 10px;
}

.mr15 {
    margin-right: 15px;
}

.changeSender {
    color: #fd5902;
    font-family: Lucida Grande, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 10px;
    cursor: pointer;
}

.example{
    font-size:12px;
    color: #2E6CDE;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor: pointer;
    line-height: 20px;
}

>>>.ant-modal-title{
    font-weight: 500!important;
}

>>>.ant-modal-footer{
    display: none;
}

>>>.ant-modal-content{
    width: 422px;
    height: 693px;
    position: absolute;
    left: 50%; 
    transform: translateX(-50%);
}

>>>.ant-modal-body{
    padding: 0 24px;
}

>>>.ant-modal-body>p>img{
    width: 100%;
    object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/common/express/SenderForm.vue